import { strapiInstance } from '@/constants/axios.instances.constants';
import type { UseApiCall } from '@/hooks/useStrapiApi';
import { buildStrapiUrl, loadAbort } from '@/utils';
import type { OfertaTrabajo, StrapiListRequest, StrapiListResponse } from '@/interfaces/strapi';
import type { OfertaTrabajoModel, StrapiResponseModel } from '@/interfaces/model';
import { ofertasTrabajoListMapper } from '@/mappers';

export const getJobOffers = ({
	pagination,
	filter,
	sort,
	populate,
}: StrapiListRequest): UseApiCall<StrapiListResponse<OfertaTrabajo>> => {
	const controller = loadAbort();

	const url = buildStrapiUrl({
		base: '/ofertas-de-trabajos',
		pagination,
		filter: typeof filter === 'object' ? filter : undefined,
		sort,
		populate,
	});

	return {
		call: strapiInstance.get(url, {
			signal: controller.signal,
			transformResponse: [
				(raw: string) => {
					const json = JSON.parse(raw) as StrapiResponseModel<OfertaTrabajoModel>;
					return ofertasTrabajoListMapper(json);
				},
			],
		}),
		controller,
	};
};
